import React from 'react';
import { ArrowRight } from 'lucide-react';

const ProjectsPage = () => {
  const projects = [
    {
      id: 'cloud-automation',
      title: 'Cloud Automation at Syntasa',
      description: 'Built out terraform automation and deployment modules across AWS and GCP platforms, enhancing Spark workloads with Kubernetes support.',
      image: '/assets/images/projects/cloud-automation.png',
      technologies: ['AWS', 'GCP', 'Terraform', 'Kubernetes', 'Spark', 'Hadoop'],
      path: '/projects/cloud-automation'
    },
    {
      id: 'aws-migration',
      title: 'AWS SaaS Migration',
      description: 'Migrated from DigitalOcean PaaS to AWS SaaS with serverless architecture and React frontend.',
      image: '/assets/images/projects/aws-migration.jpg',
      technologies: ['AWS Lambda', 'API Gateway', 'CloudFront', 'S3', 'Cognito', 'React'],
      path: '/projects/aws-migration'
    },
    {
      id: 'gcp-oklahoma',
      title: 'Google Partner Project for Oklahoma Modernization',
      description: 'Designed GCP data warehouse infrastructure with hub-and-spoke model for automated Airflow deployments.',
      image: '/assets/images/projects/gcp-oklahoma.jpg',
      technologies: ['GCP', 'Terraform', 'BigQuery', 'Dataproc', 'GKE', 'Airflow'],
      path: '/projects/gcp-oklahoma'
    },
    {
      id: 'data-visualization',
      title: 'Data Visualization Improvements',
      description: 'Enhanced pipeline maturity, refactored permission systems, and standardized API code structure.',
      image: '/assets/images/projects/data-visualization.jpg',
      technologies: ['DevOps', 'API Design', 'Security', 'Testing', 'Integration'],
      path: '/projects/data-visualization'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">My Projects</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A showcase of my work in cloud engineering, infrastructure automation, and data engineering.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div 
              key={project.id}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300"
            >
              <div className="h-48 bg-gray-200 relative">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    // Fallback if image fails to load
                    e.target.style.display = 'none';
                    e.target.parentNode.classList.add('flex', 'items-center', 'justify-center');
                    e.target.parentNode.innerHTML = `<div class="text-4xl font-bold text-gray-400">${project.title.charAt(0)}</div>`;
                  }}
                />
              </div>
              <div className="p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">{project.title}</h2>
                <p className="text-gray-600 mb-4">{project.description}</p>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.technologies.map((tech, index) => (
                    <span 
                      key={index}
                      className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                
                <a
                  href={project.path}
                  className="text-blue-600 font-semibold inline-flex items-center hover:text-blue-800 transition duration-300"
                >
                  View Case Study <ArrowRight className="ml-2" size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;